import { render, staticRenderFns } from "./OrderSpreadsheetFormatsList.vue?vue&type=template&id=001dabee&"
import script from "./OrderSpreadsheetFormatsList.vue?vue&type=script&lang=js&"
export * from "./OrderSpreadsheetFormatsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports